// Maps UI placement values to aspect-ratio keys understood by the analyzer
export const mapFacebookPlacementToAspectKey = (placement: string): string => {
  switch (placement) {
    case "feed":
      return "facebook_feed";
    case "profile_feed":
      return "facebook_profile_feed";
    case "video_feeds":
      return "facebook_video_feeds";
    case "marketplace":
      return "facebook_marketplace";
    case "facebook_reels":
    case "facebook_reels_overlay":
      return "facebook_reels";
    case "story":
      return "facebook_stories";
    case "instream_video":
      return "facebook_instream_reels";
    default:
      return placement;
  }
};

export const mapInstagramPlacementToAspectKey = (placement: string): string => {
  switch (placement) {
    case "stream":
      return "instagram_feed";
    case "reels":
      return "instagram_reels";
    case "story":
      return "instagram_stories";
    case "explore":
      return "instagram_explore";
    case "explore_home":
      return "instagram_explore_home";
    case "profile_feed":
      return "instagram_feed";
    case "ig_search":
      return "instagram_search_results";
    default:
      return placement;
  }
};
